import { LENGTH_VALUES } from '../../constants/validations';

export default value => {
  const ssnLong = new RegExp(
    `(^[0-9]{${LENGTH_VALUES.SSN}}$)|(^[0-9]{${LENGTH_VALUES.SSN_LAST_4}}$)`,
  );

  return !value || ssnLong.test(value);
};



// WEBPACK FOOTER //
// ./src/utils/validations/ruleForSSN.js